import React from 'react';
import { Card } from 'reactstrap';
import './css/FeaturedCreatorCard.css';
import {
  DEFAULT_USER_AVATAR,
  DEFAULT_FEATURED_PROFILE_BANNER
} from '../../shared/constants/common';
import LazyImage from '../../components/LazyImage/LazyImage';
import ViewProfileButton from '../buttons/ViewProfileButton';
import { getSubscriptionPriceWithExtraCharge } from '../../shared/utils/paymentUtil';
import { truncateUsernameDisplay } from '../../shared/utils/usernameFormat';

const FeaturedCreatorCard = ({
  creator,
  vatPercentage = 0,
}) => {
  return (
    <div className="featured-col">
      <Card className="featured-card">
        <div className="featured-card-header">
          <div className="featured-card-top-border"></div>
          <div className="featured-card-content">
            <div className="creator-info">
              <LazyImage
                src={creator?.avatar}
                alt="Creator Avatar"
                className="creator-avatar"
                onError={(e) => {
                  e.target.src = DEFAULT_USER_AVATAR;
                }}
              />
              <div className="creator-details">
                <h3 className="creator-username">{truncateUsernameDisplay(creator.username)}</h3>

                <div className="creator-price">
                  <span className="price-text">
                    {creator?.price ?
                      `${getSubscriptionPriceWithExtraCharge(creator?.price, creator?.active_promotion, vatPercentage)}`
                      : 'Free to Follow'
                    }
                  </span>
                </div>

              </div>
              <div className="featured-buttons">
                <ViewProfileButton creator={creator}>
                  <button className="view-btn">
                    View
                  </button>
                </ViewProfileButton>
              </div>
            </div>
            <div className="creator-image-container">
              <LazyImage
                src={creator.image}
                alt="Creator content"
                className="h-100 creator-image"
                onError={(e) => {
                  e.target.src = DEFAULT_FEATURED_PROFILE_BANNER;
                }}
              />
            </div>
            <div className="creator-bio">
              <p>{creator.bio}</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default FeaturedCreatorCard;

